import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resourceSearchfilter'
})
export class ResourceSearchfilterPipe implements PipeTransform {
  transform(items: any[], filter: string): any {
    if (!items || !filter) {
        return items;
    }
     items = items.filter(item => item.documentTitle.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.description.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.category.toLowerCase().indexOf(filter.toLowerCase()) !== -1  || item.clinicName.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    return items;
}

}
